@use '@design/design-tokens/typography/typography' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  @include typography-v2-title-lg;
  color: var(--text-default);
  margin: 20px 0 0 20px;
}

.content {
  @include custom-scroll-minimal;
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 12px;
}

.description {
  @include typography-v2-body-base;
}

.inputWrapper {
  @include typography-v2-body-base;
}

.labels {
  @include typography-v2-body-base;
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
}

.editorWrapper {
  display: flex;
  flex-direction: column;
}

.proTip {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.footer {
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  padding: 8px 12px 12px;
}

.cancelButton {
  padding: 8px 12px;
  flex: 1 0 0;
}

.saveButton {
  padding: 8px 12px;
  flex: 1 0 0;
}
